import * as ActionTypes from './actionTypes';

const setUser = (id, email, name) => ({
  type: ActionTypes.SET_USER,
  id,
  email,
  name,
});

const clearUser = () => ({
  type: ActionTypes.CLEAR_USER,
});

export default {
  setUser,
  clearUser,
};
